import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminConsoleVpsComponent from "../../../../components/Admin/vps/AdminConsoleVpsComponent";

const AdminConsoleVps = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <AdminConsoleVpsComponent
        vpsId={ params.vpsId }
        redirectBack={ () => redirectBack() }
    />

}

export default AdminConsoleVps;